import React, { useEffect, useState } from 'react';
import Store from 'store/store';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { generateImage } from 'utils/report';
import { useDebouncedCallback } from 'use-debounce';

const { connect, selectors, actions } = Store;

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: 'fixed',
      zIndex: -1,
      pointerEvents: 'none',
      top: '-99999999px',
      left: '-99999999px'
    }
  })
);

interface ReportChartProps {
  children: any;
  chartElement: any;
  name: string;
  addReportImage: Function;
  imagesLoading: any;
  setImagesLoading: Function;
}

const ReportChart = ({
  children,
  chartElement,
  name,
  addReportImage,
  imagesLoading,
  setImagesLoading
}: ReportChartProps) => {
  const classes = useStyles();
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentImagesLoading, setCurrentImagesLoading] =
    useState(imagesLoading);

  useEffect(() => {
    setCurrentImagesLoading(imagesLoading);
  }, [imagesLoading]);

  useEffect(() => {
    if (isLoading) {
      setImagesLoading([...currentImagesLoading, name]);
    } else {
      setImagesLoading(
        currentImagesLoading.filter((imageName: string) => imageName !== name)
      );
    }
  }, [isLoading]);

  const generateReportImage = useDebouncedCallback(
    async (chartElement: any) => {
      const image = await generateImage(chartElement);
      addReportImage({ key: name, chart: image });
    },
    300
  );

  setTimeout(async () => {
    if (chartElement) {
      if (chartElement.innerHTML === content) {
        return;
      }

      setIsLoading(true);
      setContent(chartElement.innerHTML);
      generateReportImage(chartElement);
    }
  }, 200);

  return <div className={classes.wrapper}>{children}</div>;
};

export default connect(
  (state: any) => ({
    imagesLoading: selectors.reportSelectors.getImagesLoading(state),
    storedImages: selectors.reportSelectors.getImages(state)
  }),
  {
    addReportImage: actions.reportActions.addImage,
    setImagesLoading: actions.reportActions.setImagesLoading
  }
)(ReportChart);
